import React from 'react';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {useEffect, useState, useRef} from 'react';
import {ASSETTRANSFER_API, ASSET_API, DEPARTMENT_API, ASSETSTATUS_API} from '@app/utils/apiUrl';
import {ASSET_STATUS_NUMBER} from '@app/store/constants';
import {Get, Put} from '@app/utils/httpProvider';
import Select from 'react-select';
import {useSelector} from 'react-redux';
import {objectShowNumber} from '../../utils/define';
import {getRoleUser} from '@app/utils/httpClient';
import {toast} from 'react-toastify';
import ReactToPrint from 'react-to-print';
import AssetTransferListPrintTemplate from './AssetTransferListPrintTemplate';

const AssetTransferList = () => {
    // 1. Thêm state để quản lý giá trị lọc
    const [assetTransfers, setAssetTransfers] = React.useState([]);
    const [assets, setAssets] = React.useState([]);
    const [departments, setDepartments] = React.useState([]);
    const [assetStatuses, setAssetStatuses] = React.useState([]);
    const [filterStatus, setFilterStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [userRole, setUserRole] = useState('');
    const valueSearch = useSelector((state) => state.search.valueSearch);

    // Tính toán isAdmin và isPartient từ mảng role (giống MaintenanceBatchList)
    const isAdmin = Array.isArray(userRole)
        ? userRole.some((r) => r.toLowerCase() === 'admin')
        : typeof userRole === 'string' && userRole.toLowerCase() === 'admin';
    const isPartient = Array.isArray(userRole)
        ? userRole.some((r) => r.toLowerCase() === 'partient')
        : typeof userRole === 'string' && userRole.toLowerCase() === 'partient';

    const todayStr = new Date().toISOString().split('T')[0];

    // State quản lý Modal và item đang được chỉnh sửa
    const [showModal, setShowModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '38px',
            height: '38px',
            borderRadius: '6px',
            borderColor: state.isFocused ? '#86b7fe' : '#ced4da',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#86b7fe'
            }
        }),

        valueContainer: (base) => ({
            ...base,
            height: '38px',
            padding: '0 12px'
        }),

        input: (base) => ({
            ...base,
            margin: 0,
            padding: 0
        }),

        singleValue: (base) => ({
            ...base,
            margin: 0,
            color: '#6c757d',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),

        placeholder: (base) => ({
            ...base,
            margin: 0,
            color: '#6c757d',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),

        indicatorsContainer: (base) => ({
            ...base,
            height: '38px'
        }),

        dropdownIndicator: (base) => ({
            ...base,
            padding: '0 8px'
        }),

        clearIndicator: (base) => ({
            ...base,
            padding: '0 8px'
        }),

        indicatorSeparator: (base) => ({
            ...base,
            backgroundColor: '#ced4da',
            marginTop: '8px',
            marginBottom: '8px',
            width: '1px'
        }),

        menu: (base) => ({
            ...base,
            zIndex: 9999
        })
    };

    // 1. Gọi API lấy danh sách tài sản điều chuyển khi component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                const role = await getRoleUser();
                setUserRole(role);
                //  setUserRole('partient');
                const [assetTransferRes, assetRes, departmentRes, statusRes] =
                    await Promise.all([
                        Get(ASSETTRANSFER_API.GET_PAGING, null, {
                            PageIndex: 1,
                            PageSize: 10000
                        }),
                        Get(ASSET_API.GET_PAGING, null, {
                            PageIndex: 1,
                            PageSize: 10000
                        }),
                        Get(DEPARTMENT_API.GET_PAGING, null, {
                            PageIndex: 1,
                            PageSize: 10000
                        }),
                        Get(ASSETSTATUS_API.GET_PAGING, null, {
                            PageIndex: 1,
                            PageSize: 10000
                        })
                    ]);

                const assetTransferData = assetTransferRes?.data || [];
                const assetData = assetRes?.data || [];
                const departmentData = departmentRes?.data || [];
                const statusData = statusRes?.data || [];
                
                const allowedCodes = ['NEW', 'IN_USE', 'BROKEN'];
                const filteredStatusData = statusData.filter(status => allowedCodes.includes(status.statusCode));

                setAssetTransfers(assetTransferData);
                setAssets(assetData);
                setDepartments(departmentData);
                setAssetStatuses(filteredStatusData);

                console.log('Dữ liệu tài sản điều chuyển:', departmentData);
            } catch (error) {
                console.error('Không thể kết nối đến API:', error);
            }
        };

        fetchData();
    }, []);

    // Logic sắp xếp: Mới nhất lên đầu (Giảm dần)
    const sortedData = [...assetTransfers].sort((a, b) => {
        return new Date(b.transferDate) - new Date(a.transferDate);
    });
    const assetMap = Object.fromEntries(assets.map((a) => [a.id, a]));
    const departmentMap = Object.fromEntries(departments.map((d) => [d.id, d]));

    const filteredData = sortedData.filter((item) => {
        // lọc theo trạng thái
        if (filterStatus && item.status !== filterStatus) {
            return false;
        }

        // nếu không có search thì giữ nguyên
        if (!valueSearch) return true;

        const asset = assetMap[item.assetId];
        const fromDepartment = departmentMap[item.fromDepartmentId];
        const toDepartment = departmentMap[item.toDepartmentId];

        const keyword = valueSearch.toLowerCase();

        return (
            asset?.assetCode?.toLowerCase().includes(keyword) ||
            asset?.assetName?.toLowerCase().includes(keyword) ||
            asset?.cardNumber?.toLowerCase().includes(keyword) ||
            fromDepartment?.departmentName?.toLowerCase().includes(keyword) ||
            toDepartment?.departmentName?.toLowerCase().includes(keyword)
        );
    });

    useEffect(() => {
        setCurrentPage(1);
    }, [valueSearch]);

    // Lấy danh sách duy nhất các Trạng thái để đổ vào dropdown lọc
    const statusOptions = [
        ...new Set(assetTransfers.map((item) => item.status))
    ].map((loc) => ({
        value: loc,
        label: loc
    }));

    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / pageSize);

    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
    }

    const updateAssetDepartment = async (assetId, toDepartmentId) => {
        try {
            const payload = {
                id: assetId,
                fieldName: 'CurrentDepartmentId',
                value: toDepartmentId
            };

            await Put(`${ASSET_API.UPDATE_FIELD}`, null, payload);
        } catch (error) {
            console.error('Lỗi update CurrentDepartmentId:', error);
            throw error;
        }
    };

    const updateStatus = async (id, newStatus) => {
        try {
            // tìm assetTransfer hiện tại
            const item = assetTransfers.find((x) => x.id === id);

            if (!item) return;

            const payload = {
                assetId: item.assetId,
                fromDepartmentId: item.fromDepartmentId,
                toDepartmentId: item.toDepartmentId,
                requestDate: item.requestDate,
                requestedBy: item.requestedBy,
                receivedBy: item.receivedBy || '',
                approvedBy: item.approvedBy || '',
                approvedDate: item.approvedDate || '',
                transferDate: item.transferDate,
                status: newStatus,
                targetStatusId: item.targetStatusId
            };
            if (
                item.status === 'Đã duyệt' &&
                newStatus === 'Đã hoàn thành' &&
                !item.transferDate
            ) {
                payload.transferDate = new Date().toISOString();
            }
            await Put(`${ASSETTRANSFER_API.UPDATE_ITEM}`, id, payload);

            if (item.status === 'Chờ phê duyệt' && newStatus === 'Đã duyệt') {
                try {
                    const payload = {
                        id: item.assetId,
                        fieldName: 'AssetStatusId',
                        value: ASSET_STATUS_NUMBER.TRANSFERING
                    };

                    await Put(`${ASSET_API.UPDATE_FIELD}`, null, payload);
                } catch (error) {
                    console.error('Lỗi update AssetStatusId:', error);
                    throw error;
                }
            }

            if (
                newStatus === 'Đã hoàn thành' ||
                newStatus === 'Không phê duyệt'
            ) {
                // Chỉ chạy riêng cho "Đã hoàn thành"
                if (newStatus === 'Đã hoàn thành') {
                    await updateAssetDepartment(
                        item.assetId,
                        item.toDepartmentId
                    );
                    // Cập nhật Người sử dụng/phụ trách (Manager) thành Người nhận (ReceivedBy)
                    if (item.receivedBy) {
                        try {
                            const payload = {
                                id: item.assetId,
                                fieldName: 'Manager',
                                value: item.receivedBy
                            };
                            await Put(`${ASSET_API.UPDATE_FIELD}`, null, payload);
                        } catch (error) {
                            console.error('Lỗi update Asset Manager:', error);
                        }
                    }
                }

                try {
                    const payload = {
                        id: item.assetId,
                        fieldName: 'AssetStatusId',
                        value: item.targetStatusId || ASSET_STATUS_NUMBER.IN_USE
                    };

                    await Put(`${ASSET_API.UPDATE_FIELD}`, null, payload);
                } catch (error) {
                    console.error('Lỗi update AssetStatusId:', error);
                    throw error;
                }
            }

            // update state nếu API thành công
            setAssetTransfers((prev) =>
                prev.map((item) =>
                    item.id === id ? {...item, ...payload} : item
                )
            );
        } catch (error) {
            console.error('Lỗi khi cập nhật trạng thái:', error);
            alert('Không thể cập nhật trạng thái!');
        }
    };

    // Hàm mở Modal và lưu item đang sửa
    const handleOpenEditModal = (item) => {
        setEditingItem(item);
        setShowModal(true);
    };

    // Hàm đóng Modal
    const handleCloseModal = () => {
        setShowModal(false);
        setEditingItem(null);
    };

    // Nút Làm mới: Reset lại editingItem về dữ liệu gốc từ danh sách assetTransfers
    const handleResetForm = () => {
        if (editingItem && editingItem.id) {
            const originalItem = assetTransfers.find(
                (x) => x.id === editingItem.id
            );
            if (originalItem) setEditingItem({...originalItem});
        }
    };

    // Nút Lưu phiếu: Gửi API Put với thông tin mới
    const handleSaveModal = async () => {
        if (!editingItem) return;

        if (!editingItem.requestedBy.trim()) {
            toast.warning('Vui lòng nhập Người đề nghị');
            return;
        }

        // 1. Kiểm tra Nơi đến trùng Nơi đi
        if (
            Number(editingItem.fromDepartmentId) ===
            Number(editingItem.toDepartmentId)
        ) {
            toast.warning('Nơi đến không được trùng với Nơi đi!');
            return; // Dừng lại, không thực hiện lưu
        }

        try {
            const payload = {
                assetId: editingItem.assetId,
                fromDepartmentId: editingItem.fromDepartmentId,
                toDepartmentId: editingItem.toDepartmentId,
                requestDate: editingItem.requestDate,
                requestedBy: editingItem.requestedBy,
                receivedBy: editingItem.receivedBy || '',
                approvedBy: editingItem.approvedBy || '',
                approvedDate: editingItem.approvedDate || '',
                transferDate: editingItem.transferDate,
                status: editingItem.status,
                targetStatusId: editingItem.targetStatusId ? Number(editingItem.targetStatusId) : null
            };

            await Put(
                `${ASSETTRANSFER_API.UPDATE_ITEM}`,
                editingItem.id,
                payload
            );

            // Cập nhật lại table với dữ liệu mới vừa sửa
            setAssetTransfers((prev) =>
                prev.map((item) =>
                    item.id === editingItem.id ? {...item, ...payload} : item
                )
            );

            alert('Lưu phiếu thành công!');
            handleCloseModal(); // Đóng Modal sau khi lưu thành công
        } catch (error) {
            console.error('Lỗi khi lưu phiếu:', error);
            alert('Đã xảy ra lỗi khi lưu thông tin phiếu!');
        }
    };

    // Hàm xử lý render UI trạng thái giống hình ảnh
    const renderStatusBadge = (status) => {
        let bgColor = 'bg-secondary';
        let icon = 'fa-info-circle';
        let textColor = 'text-white';

        // Map các trạng thái
        if (status === 'Đã duyệt' || status === 'Đã hoàn thành') {
            bgColor = '#20c997'; // Màu xanh lá giống ảnh
            icon = 'fa-check-circle';
        } else if (status === 'Không phê duyệt') {
            bgColor = '#f05050'; // Màu đỏ giống ảnh
            icon = 'fa-times-circle';
        } else if (status === 'Đang sửa chữa') {
            bgColor = '#4285f4'; // Màu xanh dương giống ảnh
            icon = 'fa-wrench';
        } else if (status === 'Chờ phê duyệt') {
            bgColor = '#ffc107'; // Vàng
            textColor = 'text-dark';
            icon = 'fa-clock';
        }

        return (
            <span
                className={`badge ${textColor} px-2 py-2 d-inline-flex align-items-center justify-content-center`}
                style={{
                    backgroundColor: bgColor,
                    fontSize: '11px',
                    borderRadius: '6px',
                    fontWeight: 700,
                    minWidth: '60px',
                    height: '24px'
                }}
            >
                <i
                    className={`fas ${icon}`}
                    style={{marginRight: '4px', fontSize: '10px'}}
                ></i>
                <span style={{textTransform: 'uppercase'}}>{status}</span>
            </span>
        );
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm">
                        <div className="card-header bg-white py-3">
                            <h5 className="card-title fw-bold text-primary mb-0">
                                <i className="fas fa-exchange-alt mr-2" />
                                Danh sách tài sản điều chuyển
                            </h5>
                        </div>

                        <div className="card-body">
                            <div className="row mb-3 align-items-center">
                                {/* Filter & Page Size - Bottom on Mobile */}
                                <div className="col-12 d-flex flex-wrap align-items-center justify-content-start" style={{ gap: '1rem' }}>
                                    <div className="d-flex align-items-center mb-2 mb-md-0">
                                        <label className="mr-2 mb-0 text-nowrap">Hiển thị:</label>
                                        <select
                                            id="showNumber"
                                            className="form-control form-control-sm"
                                            value={pageSize}
                                            onChange={(e) => {
                                                setPageSize(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            style={{width: 'auto'}}
                                        >
                                            {objectShowNumber.map((item, key) => (
                                                <option key={Number(key)} value={item.value}>
                                                    {item.text}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div style={{width: '220px'}} className="mb-2 mb-md-0 filter-status-container">
                                        <Select
                                            options={statusOptions}
                                            value={statusOptions.find((option) => option.value === filterStatus) || null}
                                            onChange={(selectedOption) => {
                                                setFilterStatus(selectedOption ? selectedOption.value : '');
                                                setCurrentPage(1);
                                            }}
                                            placeholder="-- Tất cả trạng thái --"
                                            isClearable={true}
                                            isSearchable={true}
                                            styles={customStyles}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Table */}
                            <div className="table-responsive">
                                <Table striped bordered hover className="mb-0 mobile-card-view">
                                    <thead>
                                        <tr>
                                            <th className="fw-bold px-3 text-center">
                                                STT
                                            </th>
                                            <th className="fw-bold px-3">
                                                Mã tài sản
                                            </th>
                                            <th className="fw-bold px-3">
                                                Tên tài sản
                                            </th>
                                            <th className="fw-bold px-3">
                                                Ngày điều chuyển
                                            </th>
                                            <th className="fw-bold px-3">
                                                Nơi đi
                                            </th>
                                            <th className="fw-bold px-3">
                                                Nơi đến
                                            </th>
                                            <th className="fw-bold px-3">
                                                Người nhận
                                            </th>
                                            <th className="fw-bold px-3 text-center">
                                                Trạng thái
                                            </th>
                                            <th className="fw-bold px-3 text-center">
                                                Hành động
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((item, index) => {
                                            const asset =
                                                assetMap[item.assetId];
                                            const fromDepartment =
                                                departmentMap[
                                                    item.fromDepartmentId
                                                ];
                                            const toDepartment =
                                                departmentMap[
                                                    item.toDepartmentId
                                                ];

                                            return (
                                                <tr key={item.id}>
                                                    <td className="px-3 text-center align-middle font-weight-light" data-label="STT">
                                                        {startIndex + index + 1}
                                                    </td>
                                                    <td className="px-3 align-middle fw-bold text-dark" data-label="MÃ TÀI SẢN">
                                                        {asset?.assetCode}
                                                    </td>
                                                    <td className="px-3 align-middle" data-label="TÊN TÀI SẢN">
                                                        {asset?.assetName}
                                                    </td>
                                                    <td className="px-3 align-middle" data-label="NGÀY ĐIỀU CHUYỂN">
                                                        {item.transferDate
                                                            ? new Date(
                                                                  item.transferDate
                                                              ).toLocaleDateString(
                                                                  'vi-VN'
                                                              )
                                                            : ''}
                                                    </td>
                                                    <td className="px-3 align-middle" data-label="NƠI ĐI">
                                                        {
                                                            fromDepartment?.departmentName
                                                        }
                                                    </td>
                                                    <td className="px-3 align-middle" data-label="NƠI ĐẾN">
                                                        {
                                                            toDepartment?.departmentName
                                                        }
                                                    </td>
                                                    <td className="px-3 align-middle" data-label="NGƯỜI NHẬN">
                                                        {item.receivedBy}
                                                    </td>

                                                    {/* SỬ DỤNG HÀM RENDER MỚI Ở ĐÂY */}
                                                    <td className="px-3 text-center align-middle" data-label="TRẠNG THÁI">
                                                        {renderStatusBadge(
                                                            item.status
                                                        )}
                                                    </td>

                                                    <td className="text-center align-middle">
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            {/* Chỉ hiển thị action button nếu role là admin */}
                                                            {isAdmin && (
                                                                <>
                                                                    {item.status ===
                                                                        'Đã duyệt' && (
                                                                        <button
                                                                            onClick={() =>
                                                                                updateStatus(
                                                                                    item.id,
                                                                                    'Chờ phê duyệt'
                                                                                )
                                                                            }
                                                                            className="btn btn-xs btn-outline-warning mr-1"
                                                                            title="Bỏ duyệt"
                                                                            style={{
                                                                                width: '28px',
                                                                                height: '28px',
                                                                                padding:
                                                                                    '0',
                                                                                display:
                                                                                    'inline-flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                justifyContent:
                                                                                    'center'
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className="fas fa-times"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '13px'
                                                                                }}
                                                                            />
                                                                        </button>
                                                                    )}

                                                                    {item.status ===
                                                                        'Chờ phê duyệt' && (
                                                                        <>
                                                                            <button
                                                                                onClick={() =>
                                                                                    updateStatus(
                                                                                        item.id,
                                                                                        'Đã duyệt'
                                                                                    )
                                                                                }
                                                                                className="btn btn-xs btn-outline-success mr-1"
                                                                                title="Phê duyệt"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    padding:
                                                                                        '0',
                                                                                    display:
                                                                                        'inline-flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'center'
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fas fa-check"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '13px'
                                                                                    }}
                                                                                />
                                                                            </button>
                                                                            <button
                                                                                onClick={() =>
                                                                                    updateStatus(
                                                                                        item.id,
                                                                                        'Không phê duyệt'
                                                                                    )
                                                                                }
                                                                                className="btn btn-xs btn-outline-danger mr-1"
                                                                                title="Không phê duyệt"
                                                                                style={{
                                                                                    width: '28px',
                                                                                    height: '28px',
                                                                                    padding:
                                                                                        '0',
                                                                                    display:
                                                                                        'inline-flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    justifyContent:
                                                                                        'center'
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    className="fas fa-times"
                                                                                    style={{
                                                                                        fontSize:
                                                                                            '13px'
                                                                                    }}
                                                                                />
                                                                            </button>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                            {/* --- ROLE PARTIENT / PATIENT --- */}
                                                            {(isPartient ||
                                                                isAdmin) && (
                                                                <>
                                                                    {item.status ===
                                                                        'Đã duyệt' && (
                                                                        <button
                                                                            onClick={() =>
                                                                                updateStatus(
                                                                                    item.id,
                                                                                    'Đã hoàn thành'
                                                                                )
                                                                            }
                                                                            className="btn btn-xs btn-outline-primary mr-1"
                                                                            title="Xác nhận điều chuyển"
                                                                            style={{
                                                                                width: '28px',
                                                                                height: '28px',
                                                                                padding:
                                                                                    '0',
                                                                                display:
                                                                                    'inline-flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                justifyContent:
                                                                                    'center'
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className="fas fa-exchange-alt"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '13px'
                                                                                }}
                                                                            />
                                                                        </button>
                                                                    )}

                                                                    {item.status ===
                                                                        'Chờ phê duyệt' && (
                                                                        <button
                                                                            onClick={() =>
                                                                                handleOpenEditModal(
                                                                                    item
                                                                                )
                                                                            }
                                                                            className="btn btn-xs btn-outline-primary mr-1"
                                                                            title="Sửa phiếu"
                                                                            style={{
                                                                                width: '28px',
                                                                                height: '28px',
                                                                                padding:
                                                                                    '0',
                                                                                display:
                                                                                    'inline-flex',
                                                                                alignItems:
                                                                                    'center',
                                                                                justifyContent:
                                                                                    'center'
                                                                            }}
                                                                        >
                                                                            <i
                                                                                className="fas fa-wrench"
                                                                                style={{
                                                                                    fontSize:
                                                                                        '13px'
                                                                                }}
                                                                            />
                                                                        </button>
                                                                    )}
                                                                </>
                                                            )}
                                                            <PrintAction
                                                                item={item}
                                                                asset={asset}
                                                                fromDepartment={
                                                                    fromDepartment
                                                                }
                                                                toDepartment={
                                                                    toDepartment
                                                                }
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>

                                </Table>
                            </div>

                            {/* Pagination */}
                            <nav className="d-flex justify-content-end mt-3">
                                <ul className="pagination pagination-sm mb-0">
                                    <li
                                        className={`page-item ${
                                            currentPage === 1 ? 'disabled' : ''
                                        }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage(currentPage - 1)
                                            }
                                        >
                                            «
                                        </button>
                                    </li>

                                    {pages.map((page) => (
                                        <li
                                            key={page}
                                            className={`page-item ${
                                                currentPage === page
                                                    ? 'active'
                                                    : ''
                                            }`}
                                        >
                                            <button
                                                className="page-link"
                                                onClick={() =>
                                                    setCurrentPage(page)
                                                }
                                            >
                                                {page}
                                            </button>
                                        </li>
                                    ))}

                                    <li
                                        className={`page-item ${
                                            currentPage === totalPages
                                                ? 'disabled'
                                                : ''
                                        }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            »
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* MODAL SỬA PHIẾU */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                centered
            >
                <Modal.Header className="custom-close-modal">
                    <Modal.Title className="fw-bold fs-4">
                        Sửa phiếu điều chuyển
                    </Modal.Title>
                    <button
                        type="button"
                        className="close"
                        onClick={handleCloseModal}
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Form>
                        <Row className="mb-4">
                            {/* 1. Người đề nghị */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        1. Người đề nghị
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập họ tên..."
                                        value={editingItem?.requestedBy || ''}
                                        onChange={(e) =>
                                            setEditingItem({
                                                ...editingItem,
                                                requestedBy: e.target.value
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {/* Người nhận */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        Người nhận
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Nhập họ tên người nhận..."
                                        value={editingItem?.receivedBy || ''}
                                        onChange={(e) =>
                                            setEditingItem({
                                                ...editingItem,
                                                receivedBy: e.target.value
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {/* 2. Ngày đề nghị */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        2. Ngày đề nghị
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        style={{
                                            backgroundColor: '#e9ecef',
                                            color: '#6c757d'
                                        }}
                                        value={
                                            editingItem?.requestDate
                                                ? new Date(
                                                      editingItem.requestDate
                                                  ).toLocaleDateString('en-US')
                                                : new Date().toLocaleDateString(
                                                      'en-US'
                                                  )
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            {/* 3. Mã tài sản */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        3. Mã tài sản
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        style={{
                                            backgroundColor: '#e9ecef',
                                            color: '#6c757d'
                                        }}
                                        value={
                                            assetMap[editingItem?.assetId]
                                                ?.assetCode || ''
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {/* 4. Thời gian chuyển */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        4. Thời gian chuyển
                                    </Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={
                                            editingItem?.transferDate
                                                ? editingItem.transferDate.split(
                                                      'T'
                                                  )[0]
                                                : ''
                                        }
                                        onChange={(e) =>
                                            setEditingItem({
                                                ...editingItem,
                                                transferDate: e.target.value
                                            })
                                        }
                                        onClick={(e) => {
                                            if (e.target.showPicker) {
                                                e.target.showPicker();
                                            }
                                        }}
                                        min={todayStr}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            {/* 5. Nơi đi */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        5. Nơi đi
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        readOnly
                                        style={{
                                            backgroundColor: '#e9ecef',
                                            color: '#6c757d'
                                        }}
                                        value={
                                            departmentMap[
                                                editingItem?.fromDepartmentId
                                            ]?.departmentName || ''
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            {/* 6. Nơi đến */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        6. Nơi đến
                                    </Form.Label>
                                    <Select
                                        options={departments.map((dep) => ({ value: dep.id, label: dep.departmentName }))}
                                        value={departments.map((dep) => ({ value: dep.id, label: dep.departmentName })).find((opt) => Number(opt.value) === Number(editingItem?.toDepartmentId)) || null}
                                        onChange={(selectedOption) =>
                                            setEditingItem({
                                                ...editingItem,
                                                toDepartmentId: selectedOption ? selectedOption.value : ''
                                            })
                                        }
                                        placeholder="-- Chọn phòng ban đến --"
                                        isSearchable={true}
                                        isClearable={true}
                                        noOptionsMessage={() => "Không tìm thấy phòng ban"}
                                        styles={customStyles}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            {/* 7. Trạng thái sau điều chuyển */}
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label className="fw-bold">
                                        7. Trạng thái sau điều chuyển
                                    </Form.Label>
                                    <Select
                                        options={assetStatuses.map((status) => ({ value: status.id, label: status.statusName }))}
                                        value={assetStatuses.map((status) => ({ value: status.id, label: status.statusName })).find((opt) => Number(opt.value) === Number(editingItem?.targetStatusId)) || null}
                                        onChange={(selectedOption) =>
                                            setEditingItem({
                                                ...editingItem,
                                                targetStatusId: selectedOption ? Number(selectedOption.value) : null
                                            })
                                        }
                                        placeholder="-- Chọn trạng thái sau điều chuyển --"
                                        isSearchable={true}
                                        isClearable={true}
                                        noOptionsMessage={() => "Không tìm thấy trạng thái"}
                                        styles={customStyles}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Các nút hành động */}
                        <div className="d-flex justify-content-center mt-3">
                            <button
                                type="button"
                                className="btn btn-primary px-4 py-2 mr-3"
                                style={{border: 'none', borderRadius: '4px'}}
                                onClick={handleSaveModal}
                            >
                                Lưu phiếu
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary px-4 py-2"
                                style={{
                                    border: 'none',
                                    color: '#ffffff',
                                    borderRadius: '4px'
                                }}
                                onClick={handleResetForm}
                            >
                                Làm mới
                            </button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
            
        </div>
    );
};

const PrintAction = ({item, asset, fromDepartment, toDepartment}) => {
    const componentRef = useRef();
    return (
        <>
            <div style={{display: 'none'}}>
                <AssetTransferListPrintTemplate
                    ref={componentRef}
                    data={{...item, asset, fromDepartment, toDepartment}}
                />
            </div>
            <ReactToPrint
                trigger={() => (
                    <button
                        type="button"
                        className="btn btn-xs btn-outline-secondary mr-1"
                        title="In phiếu điều chuyển"
                        style={{
                            width: '28px',
                            height: '28px',
                            padding: '0',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <i
                            className="fas fa-print"
                            style={{fontSize: '13px'}}
                        />
                    </button>
                )}
                content={() => componentRef.current}
                pageStyle="@page { size: A4 portrait; margin: 0; } @media print { body { -webkit-print-color-adjust: exact; padding: 10mm !important; } }"
            />
        </>
    );
};

export default AssetTransferList;
